import { Routes } from '@angular/router';
import { content } from './shared/routes/routes';
import { SuperadminLoginComponent } from './superadmin/auth/superadmin-login/superadmin-login.component';
import { SuperadminContentComponent } from './superadmin/superadmin-common/layout/superadmin-content/superadmin-content.component';
import { HomePageComponent } from './website/home-page/home-page.component';
import { ContentComponent } from './shared/components/layout/content/content.component';
import { portalContent } from './shared/routes/portal-routes';
import { ResetPasswordComponent } from './superadmin/auth/reset-password/reset-password.component';
import { ConfirmEmailComponent } from './superadmin/auth/confirm-email/confirm-email.component';
import { LoggedInAuthGuard } from './guard/logged-in.guard';
import { PageNotFoundComponent } from './superadmin/page-not-found/page-not-found.component';
import { PortalAuthGuard } from './guard/portal_auth.guard';
import { SuperadminAuthGuard } from './guard/superadmin_auth.guard';
import { AccessDeniedComponent } from './shared/components/access-denied/access-denied.component';
import { PortalConfirmEmailComponent } from './website/auth/portal-confirm-email/portal-confirm-email.component';

export const routes: Routes = [
  {
    path: 'home',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '',
    component: HomePageComponent,
  },
  {
    path: '',
    component: SuperadminContentComponent,
    canActivate: [SuperadminAuthGuard],
    children: content,
  },
  {
    path: 'superadmin/login',
    component: SuperadminLoginComponent,
    canActivate: [LoggedInAuthGuard]
  },
  {
    path: 'superadmin/superadmin-reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'superadmin/confirm-email',
    component: ConfirmEmailComponent,
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
   {
    path: 'portal/portal-confirm-email',
    component: PortalConfirmEmailComponent,
  },
  {
    path: '',
    // data: {
    //     title: "Home",
    //     breadcrumb: "home",

    // },
    loadChildren: () => import('../app/website/website.routes'),
  },

  {
    path: '',
    canActivate: [PortalAuthGuard], // PortalAuthGuard
    component: ContentComponent,
    children: portalContent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    data: {
      title: "404",
      breadcrumb: "404 Not Found",
    }
  },
];
